import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import { debounceTime } from 'rxjs/operators';
import { Login } from '../login/login';

@Injectable({
  providedIn: 'root'
})
export class LogPesquisaService {
  url: string;
  token: any;

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) { 
    this.url = configService.getURL() + 'log/pesquisa';
    this.token = new Login();
  }

  pesquisaPorData(data = 'now'){
    return this.http.get<Object[]>(this.url + '/' + data, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  qtdPesquisaData(data = 'now'){
    return this.http.get<Object[]>(this.url + '/qtd/' + data, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  maisPesquisadas(dataInicial: any = '', dataFinal: any = ''){
    return this.http.get<Object[]>(this.url + '/mais-pesquisadas' + '?dataInicial=' + dataInicial + '&dataFinal=' + dataFinal, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }
}
